import contractIcon from '@/images/chart/contract@2x.png';
import contractBag1 from '@/images/chart/contract-1@2x.png';
import contractBag2 from '@/images/chart/contract-2@2x.png';
import grossMarginIcon from '@/images/chart/gross-margin@2x.png';
import grossMarginBag1 from '@/images/chart/gross-margin-1@2x.png';
import grossMarginBag2 from '@/images/chart/gross-margin-2@2x.png';
import cashReturnIcon from '@/images/chart/cash-return@2x.png';
import cashReturnBag1 from '@/images/chart/cash-return-1@2x.png';
import cashReturnBag2 from '@/images/chart/cash-return-2@1x.png';
import costIcon from '@/images/chart/cost@2x.png';
import costBag1 from '@/images/chart/cost-1@2x.png';

const CHART_TOTAL_BLOCK_PROPS = {
  signingAmountTotalStr: {
    tipIcon: contractIcon,
    tipText: '总合同金额(万元)',
    backgroundColor: '#0084E7',
    backgroundImage: contractBag1,
    theme: 0,
  },
  contractAmountTotalStr: {
    tipIcon: contractIcon,
    tipText: '总合同金额(万元)',
    backgroundColor: '#0084E7',
    backgroundImage: contractBag1,
    theme: 0,
  },
  grossProfitTotalStr: {
    tipIcon: grossMarginIcon,
    tipText: '总毛利(万元)',
    backgroundColor: '#FCBB40',
    backgroundImage: grossMarginBag2,
    theme: 0,
  },
  refundAmountTotalStr: {
    tipIcon: cashReturnIcon,
    tipText: '总回款金额(万元)',
    backgroundColor: '#00D5C8',
    backgroundImage: cashReturnBag1,
    theme: 0,
  },
  costAmountTotalStr: {
    tipIcon: costIcon,
    tipText: '总成本(万元)',
    backgroundColor: '#C18CEC',
    backgroundImage: costBag1,
    theme: 0,
  },
  grossProfitPerPersonTotalStr: {
    tipIcon: grossMarginIcon,
    tipText: '人均毛利(万元)',
    backgroundColor: '#00C2EE',
    backgroundImage: grossMarginBag2,
    theme: 0,
  },
  perCapitaAmountTotalStr: {
    tipIcon: cashReturnIcon,
    tipText: '人均回款(万元)',
    backgroundColor: '#F13D7E',
    backgroundImage: cashReturnBag2,
    theme: 0,
  },
  newContractNumberTotalStr: {
    tipIcon: contractIcon,
    tipText: '总新增合同数(个)',
    backgroundColor: '#4360FF',
    backgroundImage: contractBag2,
    theme: 0,
  },
};

export default CHART_TOTAL_BLOCK_PROPS;
